
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...categoryUrl]]",
      function () {
        return require("private-next-pages/blog/[[...categoryUrl]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[[...categoryUrl]]"])
      });
    }
  